import styled, { keyframes } from "styled-components";

const rightToLeft = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;
const leftToRight = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;

export const Filter = styled.div`
	background-color: rgba(0, 0, 0, 0.4);
	position: fixed;
	top: 0;
	bottom: 0;
	left: -100%;
	width: 100%;
	height: 100%;
	z-index: 999;
	transform: translateX(0);
	&.show {
		animation: ${leftToRight} 0.5s cubic-bezier(0.3, 1.43, 0.79, 0.93) forwards;
	}
	&.hide {
		animation: ${rightToLeft} 0.5s cubic-bezier(0.3, 1.43, 0.79, 0.93) forwards;
	}
`;

export const FilterContainer = styled.div`
	background-color: #fff;
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	height: 100%;
	width: 500px;
	overflow-y: auto;
	box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
	transform: translateX(100%);
	animation: ${(props) => (props.viewAllFilters ? rightToLeft : leftToRight)}
		0.5s cubic-bezier(0.3, 1.43, 0.79, 0.93) forwards;
	z-index: 999;

	&::-webkit-scrollbar {
		width: 0;
	}
`;

export const FilterHeader = styled.header`
	padding: 12px 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #ddd;
	> span {
		font-size: 25px;
	}
`;
export const FilterContent = styled.div`
	padding: 12px 18px;

	> div {
		display: flex;
		flex-direction: column;
		margin: 10px 0;

		> input {
			min-height: 38px;
			padding: 2px 8px;
			border-color: hsl(0, 0%, 80%) !important;
			-moz-appearance: textfield;
			&::-webkit-inner-spin-button,
			&::-webkit-outer-spin-button {
				-webkit-appearance: none;
				margin: 0;
			}
		}
		> input:focus {
			box-shadow: none !important;
			border-color: #2684ff !important;
		}
		.DayPickerInput {
			width: 100%;
		}

		.DayPickerInput input {
			min-height: 38px;
			padding: 2px 8px;
			border-color: hsl(0, 0%, 80%) !important;
			width: 100%;
		}
		.DayPickerInput input:focus {
			border-color: #2684ff !important;
			box-shadow: none;
		}
	}
`;
